export const GRID_SIZE = [
  { label: '100', key: 100 },
  { label: '300', key: 300 },
  { label: '500', key: 500 },
  { label: '1000', key: 1000 },
];

export const GRID_SIZE_ENL = [
  { label: '100', key: 100 },
  { label: '300', key: 300 },
  { label: '500', key: 500 },
  { label: '5000', key: 5000 },  
];